import React from "react";
import TitlePage from "../../components/section/TitlePage/Titlepage";
import Tabs, { Tablist } from "../../components/ui/Tabs/Tabs";
import Filter from "./Components/Filter";
import { DefectReceptionTable } from "./Components/Table";

const tabs = [
  {
    title: "전체",
    id: 1,
  },
  {
    title: "불량접수",
    id: 2,
  },
  {
    title: "배송완료",
    id: 3,
  },
];

const options = [
  {
    id: 1,
    name: "상품명",
  },
  {
    id: 2,
    name: "접수번호",
  },
  {
    id: 3,
    name: "주문자(담당자)",
  },
];

const DefectReception = () => {
  const [currentTab, setCurrentTab] = React.useState(1);
  const onChangeTab = (id) => {
    setCurrentTab(id);
  };
  return (
    <>
      <TitlePage title="불량접수 관리" />
      <Tabs
        tabWidth="w-20"
        onChangeTab={onChangeTab}
        currentTab={currentTab}
        tabs={tabs}
      >
        <Tablist currentTab={currentTab} index={1}>
          <Filter options={options} isFirstTab={true} />
          <DefectReceptionTable />
        </Tablist>
        <Tablist currentTab={currentTab} index={2}>
          <Filter options={options} />
          <DefectReceptionTable />
        </Tablist>
        <Tablist currentTab={currentTab} index={3}>
          <Filter options={options} isThirdTab={true} />
          <DefectReceptionTable />
        </Tablist>
      </Tabs>
    </>
  );
};

export default DefectReception;
